import { useCurrentAccount } from '@cube3/state/src/redux/components/Administration/withCurrentUserAccount';
import { useResourceList__ALPHA } from '@cube3/state/src/redux/components/Hooks/useResourceList';
import React, { useMemo, useState } from 'react';
import {
  SuggestionItem,
  SuggestionsPickerBase
} from '../../Contracts/prefabs/MultipleResourcePicker/SuggestionsPickerBase';

export interface Props {
  placeholder?: string;
  value: SuggestionItem[];
  locked?: SuggestionItem[];
  onChange(recipients: SuggestionItem[]): void;
}
const emptyArray: SuggestionItem[] = [];
export const RecipientsPicker = (props: Props) => {
  const { value = emptyArray, placeholder, onChange, locked } = props;

  const [query, setQuery] = useState('');

  const [accountId] = useCurrentAccount();

  const params = useMemo(() => {
    return query?.trim()
      ? {
        filter: {
          query: query.trim()
        },
        page: { size: -1 }
      }
      : undefined;
  }, [query]);

  const recipients = useResourceList__ALPHA({
    resourceId: accountId,
    resourceType: 'account',
    edgeType: 'recipient',
    edgeLabel: 'recipients',
    strategy: 'fetch-on-mount',
    params
  });

  const suggestions = useMemo(() => {
    return recipients.resources
      ?.filter(
        (r) =>
          r.email_address &&
          !value.find((v) => v.email_address === r.email_address) &&
          !locked?.find((v) => v.email_address === r.email_address)
      )
      .map((s) => ({
        id: s.id,
        email_address: s.email_address,
        type: s.recipient_type
      }));
  }, [recipients.resources, locked, value]);

  return (
    <SuggestionsPickerBase
      query={query}
      setQuery={setQuery}
      locked={locked}
      value={value}
      onChange={onChange}
      suggestions={suggestions}
      primaryKey="email_address"
      placeholder={placeholder ?? 'Recipients'}
      type={'email'}
    />
  );
};
